import { render, staticRenderFns } from "./LeaveRequestEmployeeModal.vue?vue&type=template&id=6ecf0852&scoped=true"
import script from "./LeaveRequestEmployeeModal.vue?vue&type=script&lang=js"
export * from "./LeaveRequestEmployeeModal.vue?vue&type=script&lang=js"
import style0 from "./LeaveRequestEmployeeModal.vue?vue&type=style&index=0&id=6ecf0852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecf0852",
  null
  
)

export default component.exports